import React from "react";
import { getSourceAuthSetup, type SourceAuthSetupProps } from "./SourceAuthSetupRegistry";

/** Renders the source's pre-OAuth setup component, or nothing when it has none. */
export const SourceAuthSetupRenderer: React.FC<SourceAuthSetupProps> = (props) => {
  const AuthSetup = getSourceAuthSetup(props.sourceId);
  if (!AuthSetup) return null;
  // eslint-disable-next-line react-hooks/static-components
  return <AuthSetup {...props} />;
};
